import React from "react";

export const Services = () => {
  const servicesData = [
    {
      icon: "fa fa-comments-o",
      title: "Complimentary Consultation",
      text: "Treatment begins with a free 15-minute phone consultation where we'll discuss your concerns, treatment goals, and practice policies. This conversation helps ensure my clinical approach will effectively address your child's specific needs.",
    },
    {
      icon: "fa fa-search",
      title: "Comprehensive Assessment",
      text: "The initial 1-2 sessions involve a thorough evaluation of presenting symptoms, developmental history, and contributing factors. Following this assessment, you'll receive detailed feedback and we'll collaboratively develop a personalized treatment plan with clear goals.",
    },
    {
      icon: "fa fa-lightbulb-o",
      title: "Therapeutic Process",
      text: "Therapy sessions are structured, skills-based, and goal-oriented, typically lasting 45-50 minutes. We'll focus on learning and practicing effective coping strategies tailored to your child's specific challenges. Between-session practice assignments reinforce skills and accelerate progress toward treatment goals.",
    },
  ];

  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title">
          <h2>Services</h2>
          <p>
            My therapeutic approach combines proven strategies, collaboration,
            and personalized care to effectively address your child's needs.
          </p>
        </div>
        <div className="row service-cards">
          {servicesData.map((service, index) => (
            <div
              key={`${service.title}-${index}`}
              className="col-xs-12 col-md-4 practice-card"
            >
              <i className={service.icon}></i>
              <h3>{service.title}</h3>
              <p>{service.text}</p>
            </div>
          ))}
        </div>
        <div className="col-md-10 col-md-offset-1 policy-section">
          <h2>Practice Information</h2>
          <div className="row policy-row">
            <div className="col-md-6">
              <div className="policy-card">
                <h4>Telehealth Services</h4>
                <p>
                  All therapy sessions are conducted via a secure,
                  HIPAA-compliant telehealth platform.
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="policy-card">
                <h4>Fee Structure & Insurance</h4>
                <p>
                  Sessions are $250 each, payable at the time of service. While
                  I don't directly participate with insurance plans, I can
                  provide documentation for you to submit for potential
                  out-of-network reimbursement through your insurance provider.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
